<template>
    <div class="row">
        <div class="pull-right text-right col-lg-5 carousel-item-details" v-if="!collapsed">
            <div class="row">
                <div class="col-lg-7">Time:</div>
                <div class="col-lg-5">{{item.dueDateISO | formatDate('hh:mm A')}}</div>
            </div>
            <div class="row">
                <div class="col-lg-7">State:</div>
                <div class="col-lg-5"><customer-state-indicator :customerStates="item.customerStates"></customer-state-indicator></div>
            </div>
            <div class="row">
                <div class="col-lg-7">Electricity:</div>
                <div class="col-lg-5">{{item.huE}} kWh</div>
            </div>
            <div class="row">
                <div class="col-lg-7">Natural Gas:</div>
                <div class="col-lg-5">{{item.huG}} thm</div>
            </div>
        </div>
        <div class="col-lg-7">
            <div><a :href="'/partner/customer/index/id/' + item.customerId">{{item.title}}</a></div>
            <div class="carousel-item-details" v-if="!collapsed">
                <div class="row" v-if="item.contact">
                    <div class="col-lg-2">Contact:</div>
                    <div class="col-lg-10">{{item.contact}}</div>
                </div>
                <div class="row" v-if="item.address">
                    <div class="col-lg-2">Address:</div>
                    <div class="col-lg-10">{{item.address}}</div>
                </div>
                <div class="row" v-if="item.note">
                    <div class="col-lg-2">Note:</div>
                    <div class="col-lg-10"><pre>{{item.note}}</pre></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomerStateIndicator from '@/blocks/client/CustomerStateIndicator'

    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            collapsed: {
                type: Boolean,
                default: true
            }
        },
        name: 'CarouselItem',
        data () {
            return {
            }
        },
        computed: {
        },
        methods: {
        },
        components: { CustomerStateIndicator }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CarouselItem.vue?a152ef66